'use strict';

/**
 * @author Maxim Seredkin
 */

export default function() {
    return {
        restrict: 'A',
        template: require('../view/okved-select.html'),
        transclude: true,
        scope: {
            okved: '=myValue',
            mySize: '=?mySize',
            okveds: '=myOkveds',
            selectedModel: '=selectedModel',
            multiselect: '=myMultiselect',
        },
        controller: ['$scope', 'OkvedService',
                     function($scope, OkvedService) {
                         $scope.select = select;
                         $scope.clear = clear;

                         // region Function
                         function select() {
                             if ($scope.multiselect) {
                                OkvedService.select($scope.okveds[0], $scope.okveds).result.then((data) => $scope.okveds = data);
                             } else {
                                OkvedService.select($scope.okved).result.then((data) => $scope.okved = data);
                             }
                         }

                         function clear() {
                             $scope.okved = null;
                         }

                         // endregion
                     }],
    };
}
